import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

/**
 * Asked when a commission rule is edited on a campaign that has already earned sales.
 *
 * Commission is computed on the fly from the campaign's current rules - there are no
 * attribution records holding the rate a sale was sold under. So changing a rule does not
 * just affect future sales: it restates every report already produced for this campaign,
 * including periods a partner may have been paid for.
 */
function AffiliateRuleChangeDialog({ open, campaign, salescount, onCancel, onConfirm, working }) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Palkkiosääntö muuttuu takautuvasti</DialogTitle>
      <DialogContent>
        <Typography variant='body1' gutterBottom>
          Kampanjalla <b>{(campaign && campaign.name) || ''}</b> on jo{' '}
          {salescount === 1 ? 'yksi kirjattu myynti' : salescount + ' kirjattua myyntiä'}.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 2 }}>
          Palkkiot lasketaan aina kampanjan nykyisillä säännöillä, joten muutos vaikuttaa myös
          jo tehtyihin myynteihin. Kampanjan raportin luvut muuttuvat heti tallennuksen
          jälkeen — myös niiltä jaksoilta, joista kumppanille on ehkä jo maksettu.
        </Typography>
        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          Jos palkkio muuttuu vain tästä eteenpäin, tee sen sijaan uusi kampanja omalla
          koodillaan ja päätä tämä.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={working}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='warning' disabled={working}>
          {working ? 'Tallennetaan...' : 'Tallenna muutos'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AffiliateRuleChangeDialog
